<script>
  export let message = "Cargando";
  export let online = false;
</script>

<div class="d-flex align-items-center justify-content-center fg-primary w-100 overflow-hidden">
  <strong class="fg-secondary me-3 text-truncate">{message}...</strong>

  {#if online}
    <div class="spinner-grow spinner-sm fg-white me-1" role="status" />
    <div class="spinner-grow spinner-sm fg-success" role="status" />
  {:else}
    <div class="spinner-border spinner-sm fg-secondary" role="status" aria-hidden="true" />
  {/if}
</div>
